import { getCookies, setCookies } from '../hooks/useCookies';

const parseMenuList = (value) => {
  if (Array.isArray(value)) {
    return value.filter(Boolean);
  }

  if (typeof value === 'string' && value.trim()) {
    try {
      const parsed = JSON.parse(value);
      return Array.isArray(parsed) ? parsed.filter(Boolean) : [];
    } catch {
      return [];
    }
  }

  return [];
};

/** Prefer in-memory menus, then USERMENU cookie. */
export const resolveUserMenus = (userMenus) => {
  const fromState = parseMenuList(userMenus);
  if (fromState.length > 0) {
    return fromState;
  }

  return parseMenuList(getCookies('USERMENU'));
};

export const persistUserMenus = (menus) => {
  const list = parseMenuList(menus);
  if (list.length > 0) {
    setCookies('USERMENU', list);
  }
  return list;
};

export const extractMenuFromApiResponse = (data) => {
  const payload = data?.data ?? data ?? {};
  return parseMenuList(
    payload.userMenu ?? payload.userMenus ?? payload.menu ?? payload.menus
  );
};
